<template>
<div id="connection">
    <div class="info title connection clearfix">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <h1>Обеспечиваем 100% загрузку  СТО. Создаем репутацию. Обеспечиваем очередь.</h1>
                <h3>Вашего автосервиса еще нет в нашем агрегаторе?</h3>
                <h3>Направляйте заявку прямо сейчас. Для Вас это бесплатно.</h3>
                <h3>МЫ РАБОТАЕМ ВО ВСЕХ ГОРОДАХ РОССИИ</h3>
            </div>
        </div>
    </div>
    <div class="info form clearfix">
        <div class="wrapper clearfix">
            <div class="col-xs-90 col-xs-offset-15">
                <div id="application_connection">
                    <div class="col-md-40 col-sm-60">
                        <div class="field">
                            <input type="text" name="name_service" placeholder="Название сервиса" v-model="service">
                        </div>
                    </div>
                    <div class="col-md-40 col-sm-60">
                        <div class="field">
                            <input type="text" name="city" placeholder="Город" required="" v-model="citys">
                        </div>
                    </div>
                    <div class="col-md-40 col-sm-60">
                        <div class="field">
                            <input type="text" name="site" placeholder="Сайт" v-model="www">
                        </div>
                    </div>
                    <div class="col-md-40 col-sm-60">
                        <div class="field">
                            <input type="text" name="name" placeholder="Ваше имя" required="" v-model="user.name">
                        </div>
                    </div>
                    <div class="col-md-40 col-sm-60">
                        <div class="field">

                            <input v-model="user.phone" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" type="tel" name="extensionPhone" placeholder="Телефон">
                        </div>
                    </div>
                    <div class="col-md-40 col-sm-60">
                        <div class="field">
                            <input type="text" name="email" placeholder="Email" required=""  title="Пример: example@mail.ru" v-model="user.email">
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="error alert alert-danger" v-if="errors.length > 0">
                        <p v-for="(error, index) in errors" :key="index">{{error}}</p>
                    </div>
                    <div class="col-xs-120">
                        <div class="get-offer">
                            <button @click="sendOffer">Присоединиться!</button>
                        </div>
                        <div class="agree">
                            <input type="checkbox" required="" v-model="check">
                            <span>Я соглашаюсь с <router-link to="/pol-zovatel-skoe-soglashenie/" target="_blank">условиями обработки персональных данных</router-link></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-120">
                <span class="separate">Каждые 45 минут в систему добавляется новый сервис<br>Каждые 3 минуты мы получаем заявку на ремонт и записываем клиента в автосервис</span>
                <center><h2>В-Автосервис работает в России и странах СНГ</h2>

                    <img src="/static/img/general/ochered.jpg" alt="Обеспечиваем очередь">

                </center>
                <p>&nbsp;</p>

                <p><span class="bold">В-Автосервис</span> – признанный динамично развивающийся сервис ремонта автомобилей,  работающий в России и странах СНГ.</p>
                <p>Мы сделали удобный и понятный для клиентов сайт, поэтому обеспечиваем большое количество заказов</p>
                <p>Отдел маркетинга имеет прямые договоры с ведущими поисковыми системами и социальными сетями и за свой счет обеспечивает рекламу Вашего сервиса.</p>
                <p>ГОТОВЬТЕ МАСТЕРОВ! КОЛИЧЕСТВО ЗАКАЗОВ УЖЕ СКОРО СТАНЕТ БОЛЬШЕ!</p>
                <p>&nbsp;</p>
                <center><h2>Как это работает</h2><h2></h2></center>
                <div align="left">
                    <p>1.       Подключитесь к нашему агрегатору за 1 минуту. Просто определите, какой % Вы готовы платить нам за каждого клиента,
                        которого мы запишем на ремонт в Вашу СТО. </p>
                    <p>2.       Мы получаем очень много заявок на ремонт.</p>
                    <p>3.       Заявки по Вашей тематике попадают в Ваш личный кабинет. Вы можете отвечать на них, предлагать свою стоимость.</p>
                    <p>4.       Клиент выбирает СТО, условия которого ему подошли</p>
                    <p>5.       Автовладелец платит за ремонт непосредственно Вам. Никакой предоплаты мы не берем!</p>
                    <p>6.       Ваш сервис выполнил ремонт и получил от клиента деньги – Вы просто платите нашу комиссию.</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable no-useless-escape */
import axios from '@/router/http'
export default {
  name: 'Connection',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      errors: [],
      citys: this.city.name,
      www: null,
      service: null,
      check: 0,
      phone: null
    }
  },
  methods: {
    sendOffer () {
      this.errors = []
      let pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!this.service) this.errors.push('Необходимо указать название компании')
      if (!this.citys) this.errors.push('Необходимо указать город')
      if (!this.user.name) this.errors.push('Необходимо указать имя')
      if (!this.user.phone) this.errors.push('Необходимо указать телефон')
      if (!this.user.email && this.user.email !== ' ') this.errors.push('Необходимо указать почту')
      if (pattern.test(this.user.email) === false) this.errors.push('Вам необходимо ввести email, ваш текст невалиден.')
      if (!this.check) this.errors.push('Вам необходимо принять условия обработки данных')
      if (this.errors.length === 0) {
        setTimeout(function () { alert('Ваша заявка отправлена, на указанную Вами почту была отправлена информация') }, 1)
        var formData = new FormData()
        formData.append('crm', '1')
        formData.append('pipe', '4')
        formData.append('status', '52')
        formData.append('lead[name]', this.service)
        formData.append('lead[36]', this.citys)
        formData.append('note', 'Наш сайт: ' + this.www)
        formData.append('contact[name]', this.user.name)
        formData.append('contact[3]', this.user.phone)
        formData.append('contact[4]', this.user.email)
        axios.post('https://crm.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        var formDatas = new FormData()
        formDatas.append('name', this.service)
        formDatas.append('city', this.citys)
        formDatas.append('www', this.www)
        formDatas.append('contact', this.user.name)
        formDatas.append('phone', this.user.phone)
        formDatas.append('email', this.user.email)
        axios.post('https://crm.v-avtoservice.com/list/site-new-service',
          formDatas,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Connection.vue